import React from 'react'
import PropTypes from 'prop-types'

import Container from '../Container'
import { title as styles } from './styles'

const Title = ({ children, subtitle }) => (
  <section className="title">
    <Container>{children}</Container>
    {subtitle}
    <style jsx>{styles}</style>
  </section>
)

Title.propTypes = {
  children: PropTypes.any,
  subtitle: PropTypes.any
}

export default Title
